'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
Entry.db = /*#__PURE__*/function () {
  function DB() {
    (0, _classCallCheck2["default"])(this, DB);
    this.data = {};
    this.typeMap = {};
  }
  return (0, _createClass2["default"])(DB, [{
    key: "add",
    value: function add(datum) {
      this.data[datum.id] = datum;
      var type = datum.type;
      if (this.typeMap[type] === undefined) {
        this.typeMap[type] = {};
      }
      this.typeMap[type][datum.id] = datum;
    }
  }, {
    key: "has",
    value: function has(id) {
      return this.data.hasOwnProperty(id);
    }
  }, {
    key: "remove",
    value: function remove(id) {
      if (!this.has(id)) {
        return;
      }
      var datum = this.data[id];
      delete this.typeMap[datum.type][id];
      delete this.data[id];
    }
  }, {
    key: "get",
    value: function get(id) {
      return this.data[id];
    }
  }, {
    key: "find",
    value: function find() {}
  }, {
    key: "clear",
    value: function clear() {
      this.data = {};
      this.typeMap = {};
    }
  }]);
}();